import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import HistoryOfEventsTable from './HistoryOfEventsTable';

class HistoryOfEvents extends Component {
    render() {
        const {
            events,
            loading,
            pagination,
            filters,
            filtersConfig,
            applyFilters,
            clearFilters,
            removeFilter
        } = this.props;
        return (
            <Fragment>
                <h2>History of Events</h2>
                <HistoryOfEventsTable
                    events={events}
                    pagination={pagination}
                    loading={loading}
                    onPaginationUpdated={this.props.onPaginationUpdated}
                    onSortUpdated={this.props.onSortUpdated}
                    filters={filters}
                    filtersConfig={filtersConfig}
                    applyFilters={applyFilters}
                    clearFilters={clearFilters}
                    removeFilter={removeFilter}
                />
            </Fragment>
        );
    }
}

export default withRouter(HistoryOfEvents);
